export default __webpack_public_path__ + "static/media/tripnow-details.1d0ff542.PNG";